<template>
  <div class="animated fadeIn" v-if="this.$can('user','index')">
    <b-row>
      <b-col class="mb-12" cols="12">
        <b-card 
          header="Users"  
          header-bg-variant="primary"
          header-text-variant="white" 
          class="table-responsive">
          <users-filter-bar></users-filter-bar>

          <vuetable ref="vuetable"
              api-url="api/users"
              :http-options="httpOptions"
              :fields="fields"
              pagination-path=""
              :css="css.table"
              :sort-order="sortOrder"
              :multi-sort="true"
              :append-params="moreParams"
              :per-page="15"
              :options="options"
              detail-row-component="users-detail-row"
              @vuetable:cell-clicked="onCellClicked"
              @vuetable:pagination-data="onPaginationData"
          ></vuetable>

          <div class="vuetable-pagination">
              <vuetable-pagination-info 
                  ref="paginationInfo"
                  info-class="pagination-info" 
                  info-template="{from} to {to} of {total} users">
              </vuetable-pagination-info>


              <vuetable-pagination 
                  ref="pagination" 
                  :css="css.pagination" @vuetable-pagination:change-page="onChangePage">
                </vuetable-pagination>

          </div>
        </b-card>
      </b-col>
     </b-row>


<!-- <div class="tabs">
  <b-nav tabs>
    <b-nav-item to="#" :active="$route.hash === '#' || $route.hash === ''">
      One
    </b-nav-item>
    <b-nav-item to="#two" :active="$route.hash === '#two'">
      Two
    </b-nav-item>
    <b-nav-item to="#three" :active="$route.hash === '#three'">
      Three
    </b-nav-item>
  </b-nav>
  <div class="tab-content">
    <div :class="['tab-pane', { 'active': $route.hash === '#' || $route.hash === '' }]" class="p-2">
      <p>Tab One (default) with no hash</p>
    </div>
    <div :class="['tab-pane', { 'active': $route.hash === '#two' }]" class="p-2">
      <p>Tab One with hash #two</p>
    </div>
    <div :class="['tab-pane', { 'active': $route.hash === '#three' }]" class="p-2">
      <p>Tab One with hash #three</p>
    </div>
  </div>
</div> -->


</div>
</template>

<script>
import Vue from 'vue'
import VueEvents from 'vue-events'
import moment from 'moment'
import Vuetable from 'vuetable-2/src/components/Vuetable'
import VuetablePagination from 'vuetable-2/src/components/VuetablePagination'
// import VuetablePagination from 'vuetable-2/src/components/VuetablePaginationDropdown'
import VuetablePaginationDropdown from 'vuetable-2/src/components/VuetablePaginationDropdown'
import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
import UsersDetailRow from './UsersDetailRow'
import UsersFilterBar from './UsersFilterBar'
import UsersActions from './UsersActions'

Vue.use(VueEvents)
Vue.component('users-actions', UsersActions)
Vue.component('users-detail-row', UsersDetailRow)

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    UsersFilterBar,
  },  
  data () {
    return {
      options: {
          perPageValues: [10,25,50,100], // TODO:
          perPage:100,

      },
      httpOptions: { headers: { Authorization: 'Bearer ' + localStorage.getItem('token') } },
      fields: [
        // {
        //   name: '__checkbox',   // <----
        //   titleClass: 'center aligned',
        //   dataClass: 'center aligned',

        // },
        {
          name: '__sequence',   // <----
          title: '#',
          titleClass: 'center aligned',
          dataClass: 'right aligned'
        },        
        {
          name: '__component:users-actions',
          title: 'Action',
          titleClass: 'text-center',
          dataClass: 'text-center'
        },
        {
          name: 'name',
          sortField: 'name',
        },
        {
          name: 'email',
          sortField: 'email',
          title: "Login",
          // visible: false,
        },
        {
          name: 'created_at',
          sortField: 'created_at',
          callback: 'relativeTime'
        },
        {
          name: 'updated_at',
          sortField: 'updated_at',
          callback: 'relativeTime'
        }
      ],
      css: {
          table: {
            tableClass: 'table table-bordered table-striped table-sm ',
            loadingClass: 'loading',
            ascendingIcon: 'fa fa-chevron-up',
            descendingIcon: 'fa fa-chevron-down',
            detailRowClass: 'vuetable-detail-row',
            handleIcon: 'fa fa-shower',
          },
          pagination:{
            wrapperClass: "pagination pull-right",
            activeClass: "btn-primary",
            disabledClass: "disabled",
            pageClass: "btn btn-border",
            linkClass: "btn btn-border",
            icons: {
                first: "",
                prev: "",
                next: "",
                last: ""
            },
          },
      },
      sortOrder: [

        // { field: 'name', sortField: 'name', direction: 'asc'}
        { field: 'updated_at', sortField: 'updated_at', direction: 'desc'}
      ],
      moreParams: {}
    }
  },
  methods: {
    
    formatDate (value, fmt = 'D MMM YYYY') {
      return (value == null)
        ? ''
        : moment(value, 'YYYY-MM-DD').format(fmt)
    },
    relativeTime (value){
      let localTime = moment.utc(value).local();
        return (value == null) ? '-' : moment(localTime).fromNow()
    },
    // myNumFormat($value){
    //     return (value == null) ? '' : Intl.NumberFormat().format($value)
    // },
    evaluarNacionalidad(value){
        return value;
    },
    onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.$refs.paginationInfo.setPaginationData(paginationData)
    },
    onChangePage (page) {
      this.$refs.vuetable.changePage(page)
    },
    onCellClicked (data, field, event) {
      // console.log('cellClicked: ', field.name)
      // this.$refs.vuetable.toggleDetailRow(data.id)
    },       
  }, 
  events: {
    'filter-set' (filterText) {
      this.moreParams = {
        filter: filterText
      }
      Vue.nextTick( () => this.$refs.vuetable.refresh() )
    },
    'filter-reset' () {
      this.moreParams = {}
      Vue.nextTick( () => this.$refs.vuetable.refresh() )
    },
    'refreshTable'(){
      Vue.nextTick( () => this.$refs.vuetable.refresh() )
      console.log('Table Refreshed: 934749')
    },   
  }

}
</script>
<style>
  .pagination {
    margin: 0;
    float: right;
  }
  .pagination a.page {
    border: 1px solid lightgray;
    border-radius: 3px;
    padding: 5px 10px;
    margin-right: 2px;
  }
  .pagination a.page.active {
    color: white;
    background-color: #337ab7;
    border: 1px solid lightgray;
    border-radius: 3px;
    padding: 5px 10px;
    margin-right: 2px;
  }
  .pagination a.btn-nav {
    border: 1px solid lightgray;
    border-radius: 3px;
    padding: 5px 7px;
    margin-right: 2px;
  }
  .pagination a.btn-nav.disabled {
    color: lightgray;
    border: 1px solid lightgray;
    border-radius: 3px;
    padding: 5px 7px;
    margin-right: 2px;
    cursor: not-allowed;
  }
  .pagination-info {
    float: left;
  }
  
table.vuetable {
     table-layout: auto;
}


.vuetable-body > tr > td {
     white-space: nowrap;
     overflow: hidden; 
     text-overflow: ellipsis; 
}


.vuetable th#_id {
     width: 80px;
}
.vuetable th#_action {
     width: 70px;
}

</style>
